module.exports = __webpack_public_path__ + "static/media/ER-RUS1_1OIeaRvvdHvD5p3uPJDZSVGBlA0BXVno_.30e19f04.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/ER-RUS1_1OIeaRvvdHvD5p3uPJDZSVGBlA0BXVno_
// module id = 659
// module chunks = 0